/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { MaterialMasterBase } from "../../../../schema/generated/MaterialMaster";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class MaterialMasterDataApi extends EntityDataApi<MaterialMasterBase> {
  public readonly def = idbEntityDefs.MaterialMaster;
}